module.exports = __webpack_public_path__ + "9b186a8be867d7cb136d2dcdb89d8d2b.svg";